import { METRICS_EVENTS } from "@cede/types";
import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { ClaimRewardsError, useClaimRewards } from "@/hooks/user/useClaimRewards";

type UseCampaignClaimRewardsProps = {
  onClaimSuccess?: () => void;
  onClaimError?: (error: ClaimRewardsError) => void;
  enabled?: boolean;
};

export const useCampaignClaimRewards = ({
  onClaimSuccess,
  onClaimError,
  enabled = true,
}: UseCampaignClaimRewardsProps) => {
  const apiHelper = useApi();

  return useClaimRewards({
    onClaimSuccess,
    onClaimError,
    enabled,
    queryKeys: {
      claimableRewards: QueryKeys.HUB_REWARDS_CLAIMABLE,
      claimableSoonRewards: QueryKeys.HUB_REWARDS_CLAIMABLE_SOON,
    },
    fetchers: {
      getClaimableRewards: async (userAddress) => {
        const claimableRewards = await apiHelper.getOrThrow(API_ENDPOINT.HUB_REWARDS_CLAIMABLE, {
          queryParams: { defiAddress: userAddress },
        });
        return {
          ...claimableRewards.claimableEpochs,
          claimablesData: claimableRewards.claimableEpochs.claimablesData.map((claimable) => ({
            ...claimable,
            epochStart: claimable.epochStart,
            epochEnd: claimable.epochEnd,
          })),
        };
      },
      simulateClaim: async (claimItems) => {
        await apiHelper.postOrThrow(API_ENDPOINT.HUB_REWARDS_SIMULATE, {
          bodyParams: { claimItems },
        });
      },
      getClaimableSoonRewards: async (userAddress) => {
        const claimableSoonRewards = await apiHelper.getOrThrow(API_ENDPOINT.HUB_REWARDS_CLAIMABLE_SOON, {
          queryParams: { defiAddress: userAddress },
        });
        return claimableSoonRewards.claimableSoonEpochs.map((claimable) => ({
          ...claimable,
          epochStart: claimable.epochStart,
          epochEnd: claimable.epochEnd,
        }));
      },
    },
    metricsEvent: METRICS_EVENTS.CLAIM_REWARDS,
  });
};
